var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"sf-button--pure account-icon-button",on:{"click":_vm.goToAccount}},[_c('SfIcon',{staticClass:"account-icon",class:{
      'is-active': _vm.isLoggedIn,
    },attrs:{"icon":"account","size":"xs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }